import React from "react";
import TextAnimP1 from "./TextAnimP1";
import Lottie from "lottie-react";

const HomeFourthSectionCard = ({ align, content }) => {
  const isRight = align === "right";
  const textAlignClass = isRight ? "xl:text-right justify-end" : "xl:text-left";
  const marginClass = isRight ? "xl:ml-auto" : "xl:mr-auto";

  return (
    <div                                                                              
      className={`dark:text-white text-black rounded-lg max-h-[100vh] flex flex-col justify-between text-center xl:text-left xl:w-full`}
    >
      <div className="w-full overflow-hidden md:mx-auto md:w-fit">
        <Lottie
          animationData={content.lottieSrc}
          loop={true}
          autoplay={true}
          style={align == "right" ? { width: 350 } : { width: 350 }}
          className={marginClass}
        />
      </div>
      <div className={`my-3 ${textAlignClass}`}>
        <span className={`text-xs  font-semibold text-gray-600 tracking-wider uppercase ${marginClass}`}>
          {content.h2}
        </span>
      </div>
      <h2
        className={`text-2xl font-semibold ${textAlignClass}`}
        dangerouslySetInnerHTML={{ __html: content.dHead }}
      />
      <div className="space-y-4">
        <p className={`dark:text-gray-300 text-gray-600 text-lg mt-4 flex ${textAlignClass}`}>
          <div className="xl:w-[70%]">
          {content.dParagraph}
          </div>
        </p>
      </div>
    </div>
  );
};

export default HomeFourthSectionCard;
